<!-- components/LoadingIndicator.vue -->
<template>
      <div v-if="state && state.searchMetadata.isSearchStalled">
        <div class="spinner-border text-primary mb-1 spinner" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
</template>

<script>
import { createWidgetMixin } from 'vue-instantsearch';

const connectSearchMetaData = (renderFn, unmountFn) => (widgetParams = {}) => ({
  init() {
    renderFn({ searchMetadata: {} }, true);
  },

  render({ searchMetadata }) {
    renderFn({ searchMetadata }, false);
  },

  dispose() {
    unmountFn();
  },
});

export default {
  name: 'AisStateResults',
  mixins: [createWidgetMixin({ connector: connectSearchMetaData })],
};
</script>
